type ValidateSingleSelectionListOnCustomFormParams = {
  text: string
  isRequired?: boolean
}

export default function validateSingleSelectionListOnCustomForm({
  text,
  isRequired,
}: ValidateSingleSelectionListOnCustomFormParams) {
  let error = ''
  if (isRequired && !text) {
    error = 'Este campo é obrigatório'
  }

  return error
}
